import { render, staticRenderFns } from "./DetalleTaquilla.vue?vue&type=template&id=201397e2&"
import script from "./DetalleTaquilla.vue?vue&type=script&lang=js&"
export * from "./DetalleTaquilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports